import type React from "react";
import { useLocation } from "wouter";

export const AdminRoutes = {
  HOME: "/admin",
  DASHBOARD: "/admin/dashboard",
  TRAINERS: "/admin/trainers",
  OWNERS: "/admin/owners",
} as const;

export type AdminRoute = (typeof AdminRoutes)[keyof typeof AdminRoutes];

export interface AdminNavItem {
  label: string;
  route: AdminRoute;
  icon?: React.ComponentType;
}

export const useAdminNavigator = () => {
  const [, navigate] = useLocation();

  const navigator = (params: { path: AdminRoute }) => {
    return () => {
      navigate(params.path);
    };
  };

  return { navigator };
};
